export const FETCH_PLAYLISTS = 'FETCH_PLAYLISTS';
export const FETCH_SINGLE_PLAYLIST = 'FETCH_SINGLE_PLAYLIST';
